/*
 * HobbyChef — termín doručení „U vás již …" (21. 9. 2026)
 *
 * Návrh měl všude natvrdo „U vás již Čt 25.7.2026" — na produktovce, na
 * kartách v pásech pod produktem i u produktu vloženého do článku. Do
 * 21. 9. 2026 se to tak sázelo, dva měsíce po datu (a 25. 7. 2026 byla
 * sobota). Teď se datum dopočítá tady, na jednom místě pro celý web.
 *
 * Pravidlo potvrdil klient: N pracovních dnů počínaje zítřkem (globální
 * nastavení motivu „Doručení za"), bez víkendů a českých státních svátků
 * včetně Velkého pátku a Velikonočního pondělí.
 *
 * Značka v šabloně: <span data-hc-doruceni="2" data-hc-predtim="U vás již">
 * se záložní větou uvnitř. Skript ji nahradí větou s datem; bez skriptu
 * záložní věta zůstane a nic neslibuje špatně.
 *
 * Počítá se v prohlížeči, ne v Liquidu: časová pásma se v Shopify
 * a v offline rendereru chovají jinak (CLAUDE.md §26) a ověřit se to dá
 * jen na živém webu. Tady to jde otestovat v Node — tools/verify_doruceni.js.
 */
(function (w) {
  var DEN = 86400000;
  var SVATKY = ['1-1', '5-1', '5-8', '7-5', '7-6', '9-28', '10-28', '11-17', '12-24', '12-25', '12-26'];

  // Dnešek v pražském čase, ať ho návštěvník v jiném pásmu nevidí posunutý.
  // Drží se v poledne UTC, takže přičtení 24 h nepřeskočí den při změně času.
  function dnesVPraze(now) {
    var c = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Prague', year: 'numeric', month: '2-digit', day: '2-digit'
    }).format(now).split('-');
    return new Date(Date.UTC(+c[0], +c[1] - 1, +c[2], 12));
  }

  // Velikonoční neděle, anonymní gregoriánský algoritmus.
  function velikonoce(rok) {
    var a = rok % 19, b = Math.floor(rok / 100), c = rok % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var n = h + l - 7 * m + 114;
    return Date.UTC(rok, Math.floor(n / 31) - 1, (n % 31) + 1, 12);
  }

  function svatek(d) {
    if (SVATKY.indexOf((d.getUTCMonth() + 1) + '-' + d.getUTCDate()) >= 0) return true;
    var ned = velikonoce(d.getUTCFullYear());
    return d.getTime() === ned - 2 * DEN || d.getTime() === ned + DEN;
  }

  function termin(now, dni) {
    var d = dnesVPraze(now);
    while (dni > 0) {
      d = new Date(d.getTime() + DEN);
      if (d.getUTCDay() !== 0 && d.getUTCDay() !== 6 && !svatek(d)) dni--;
    }
    return d;
  }

  // Tvar z návrhu: „Čt 25.7.2026" — zkratka dne, datum bez mezer, s rokem.
  function format(d) {
    var dny = ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'];
    return dny[d.getUTCDay()] + ' ' + d.getUTCDate() + '.' + (d.getUTCMonth() + 1) + '.' + d.getUTCFullYear();
  }

  function vyplnit(koren) {
    if (!koren || !koren.querySelectorAll) return;
    var ted = new Date();
    koren.querySelectorAll('[data-hc-doruceni]').forEach(function (el) {
      var dni = parseInt(el.getAttribute('data-hc-doruceni'), 10);
      if (!(dni > 0)) return;
      try {
        el.textContent = (el.getAttribute('data-hc-predtim') || 'U vás již') + ' ' + format(termin(ted, dni));
      } catch (e) {
        // Bez Intl s časovými pásmy zůstane záložní věta bez data.
      }
    });
  }

  // Pro test v Node a pro obsah, který přibude později (třeba košíkový panel).
  w.hcDoruceni = { termin: termin, format: format, velikonoce: velikonoce, vyplnit: vyplnit };

  if (typeof document !== 'undefined') vyplnit(document);
})(typeof window !== 'undefined' ? window : globalThis);
